<template>
  <ValidationField
    v-slot="{ errors }"
    v-model="innerValue"
    as="div"
    :name="name"
    :rules="rules"
  >
    <p>レビュー分析には10件以上のレビュー数が必要です。</p>
    <div
      :class="{
        'asin-field--error': errors.length > 0,
        'w-full': fullWidth
      }"
    >
      <Multiselect
        v-model="innerValue"
        rules="required"
        :options="options"
        :label="label"
        :searchable="true"
        track-by="value"
        placeholder="選択または入力してください"
        select-label="選択"
        selected-label=""
        deselect-label="選択解除"
        no-options=""
        @open="onOpen"
        @close="onClose"
      >
        <template #noResult>
          <span>該当するASINがありません</span>
        </template>
        <template #noOptions>
          {{ noOptionText }}
        </template>
        <template #option="{ option }">
          <div class="flex flex-col text-xs">
            <div class="truncate text">
              {{ option.text }}
            </div>
          </div>
        </template>
      </Multiselect>
    </div>
    <div
      v-if="errors.length > 0"
      style="height: 26px;"
      class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
    >
      <span class="span-text-validation">
        {{ errors[0] }}
      </span>
    </div>
  </ValidationField>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'AsinField',
  components: {
    Multiselect
  },
  props: {
    modelValue: {
      type: [String, Object, Array],
      default: null
    },
    name: {
      type: String,
      default: 'ASIN'
    },
    label: {
      type: String,
      default: 'text'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    noOptionText: {
      type: String,
      default: 'ASINがありません'
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      isClosed: true
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    }
  },
  methods: {
    onOpen () {
      this.isClosed = false
    },
    onClose () {
      this.isClosed = true
    }
  }
}
</script>

<style scoped>
.text {
  max-width: 590px;
}
</style>

<style>
.asin-field--error .multiselect__tags {
  border: 1px solid rgba(var(--vs-danger),1)!important;
}
</style>
